import React from 'react';
import './Spinner.css';
const Spinner = () => {
    return (
        <>
           <div className="loadingio-spinner-reload-sbu01307l4 container">
              <div className="ldio-v8liw9ovg0h">
                <div>
                  <div></div>
                    <div></div>
                    <div></div>
                 </div>
              </div> 
           </div> 
        </>

    );
}

export default Spinner;
